<template>
  <footer class="footer-responsive align-center">
    <FooterSignUpBcom v-if="!isInternational" />
    <div class="row-1">
      <nav class="nav-footer-wrapper grid-container padding-bottom-l" :class="{ international: isInternational }" aria-label="Primary footer section">
        <FooterLinksCommon />
        <FooterStayConnectedBcom />
      </nav>
    </div>
    <div class="row-2">
      <nav class="grid-container padding-top-m padding-bottom-m" aria-label="Secondary footer section">
        <FooterPrivacyLinksCommon :links="legalLinks" />
        <FooterCopyrightCommon />
        <FooterTaglineBcom />
      </nav>
    </div>
  </footer>
</template>

<script setup>
/* v8 ignore file -- @preserve */
import { computed } from 'vue';
import { GET_LEGAL_LINKS } from '#shared/types/getters';

const pageData = usePageData();
const navFooter = useNavFooter();
const isInternational = computed(() => pageData.navigation.context.isInternational);
const legalLinks = computed(() => navFooter?.[GET_LEGAL_LINKS]);
</script>

<style lang="scss" brand="bcom" scoped>
@import '~/assets/scss/mixins.bcom.scss';

.footer-responsive {
  .row-1 {
    background-color: $background-color;

    .nav-footer-wrapper {
      @include padding-top-m;
    }

    @include breakpoint(large up) {
      .nav-footer-wrapper {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: flex-start;
        gap: map-get($grid-margin-gutters, 'medium');
        @include padding-top-l;

        :deep() {
          .footer-links-group {
            flex-grow: 1;
            flex-basis: 0;
          }
        }

        &.international {
          gap: map-get($grid-margin-gutters, 'large');
        }
      }
    }

    @include breakpoint(mlarge up) {
      .nav-footer-wrapper {
        gap: map-get($grid-margin-gutters, 'large');

        &.international {
          :deep() {
            .footer-links-group {
              flex-grow: 1;
              flex-basis: 0;

              label {
                text-transform: unset;
              }
            }
          }
        }
      }
    }
  }
  .row-2 {
    background-color: $white;
  }
}
</style>
